import { s as secureRequest } from '../../dist/secureAPI-4399d88c.esm.js';
export { s as default } from '../../dist/secureAPI-4399d88c.esm.js';
import '../../dist/asyncToGenerator-c002e3ca.esm.js';
import '@aws-amplify/auth';
